export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "delivery_product": {
            "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombre"])},
            "base_price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Precio Base"])}
          }
        }
      }
    }
  })
}